// PDP Accordion section js

 $(document).on('click assess', '.tab-lists a', function (evt) {
            // active class
            $(this).addClass('tab--active').closest('ul').find('.tab--active').not(this).removeClass('tab--active');

            // hide inactive content
            $(this).closest('li').siblings().find('a').each(function () {
              $($(this).attr('href')).removeClass('tab-content--active');
            });

            // show active content
            $($(this).attr('href')).addClass('tab-content--active');
            evt.preventDefault();
          });
// End PDP Accordion section js

// custom Variant js

var addCartVariant = $(".add_to_cart_variant_button");
var qtyVariant = $(".quantity-variant .qty-variant");
$(".increase.q__up").unbind("click");
$(".increase.q__up").click(function() {
  var p_id = $(this).attr("data-product_id");
  var q_value = parseInt($(".qty-" + p_id).val()) + 1;
  $(".qty-" + p_id).val(q_value);
  if (qtyVariant.length > 0) {
    var r_disabled = false;
    qtyVariant.each(function() {
      var qtyVariantVal = parseInt($(this).val());
console.log("qtyVariantVal", qtyVariantVal);
      var variant_id = $(this).attr("data-variant_id");
console.log("variant_id", variant_id);
      if (qtyVariantVal != 0) {
        r_disabled = true;
      }
    });
    if (r_disabled) {
      addCartVariant.removeClass("button-disabled"); 
    } else {
      !addCartVariant.hasClass("button-disabled") &&
        addCartVariant.addClass("button-disabled");
    }
  }
});
$(".decrease.q__down").unbind("click");
$(".decrease.q__down").click(function() {
  var p_id = $(this).data("product_id");
  var q_value = parseInt($(".qty-" + p_id).val());
  if (qtyVariant.length > 0) {
    if (q_value > 0) {
      $(".qty-" + p_id).val(q_value - 1);
    }
    var r_disabled = false;
    qtyVariant.each(function() {
      var qtyVariantVal = parseInt($(this).val());
      var variant_id = $(this).attr("data-variant_id");
      if (qtyVariantVal != 0) {
        r_disabled = true;
      }
    });
    if (r_disabled) {
      addCartVariant.removeClass("button-disabled");
    } else {
      !addCartVariant.hasClass("button-disabled") &&
        addCartVariant.addClass("button-disabled");
    }
  } else {
    if (q_value > 1) {
      $(".qty-" + p_id).val(q_value - 1);
    }
  }
});
$(document).ready(function() {
  $(".add_to_cart_variant_button").on("click", function(event) {
    event.preventDefault();

    var self = $(this);
$(this).val("Added to cart...")
    if (self.hasClass("button-disabled")) {
      console.log("Cannot click");
    } else {
      var queue = [];

      $('.qty-variant').each(function() {
        var variantId = $(this).data('variant_id');
        var quantity = parseInt($(this).val(), 10) || 0;

        if (quantity > 0) {
          queue.push({
            variantId: variantId,
            quantity: quantity
          });
        }
      });

      function processQueue() {
        if (queue.length) {
          var request = queue.shift();

          Shopify.addItem(request.variantId, request.quantity, function(cart) {
            console.log("Item added to cart:", cart);
            processQueue();
          });
        } else {
          window.location.href = "/cart";
        }
      }

      processQueue();
    }
  });
});

 function handleSelection() {
        $('.options-selection__option-value').removeClass('options-selection__option-value--selected');
        $(this).parent('.options-selection__option-value').addClass('options-selection__option-value--selected');
        
        var variant_name = $(this).find('input').val();
        if (variant_name.includes('kit') || variant_name.includes('Kit')) {
            $('.custom__metafields').show();
        } else {
            $('.custom__metafields').hide();
        }
    }
    
    // Bind click event to the labels
    $('.options-selection__option-value-label').click(handleSelection);

    // Execute on load
    $('.options-selection__option-value-label').each(function() {
        var variant_name = $(this).find('input').val();
        if ($(this).parent('.options-selection__option-value').hasClass('options-selection__option-value--selected')) {
            if (variant_name.includes('kit') || variant_name.includes('Kit')) {
                $('.custom__metafields').show();
            } else {
                $('.custom__metafields').hide();
            }
        }
    });
